import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultTickerStyle() {
  if (!getDefaultTickerStyle.style) {
    getDefaultTickerStyle.style = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        bottom: 'auto',
        left: '0px',
        right: '0px',
        top: 'calc(50% - 22px)',
        overflow: 'hidden',
        zIndex: 0,
      }),
      body: {
        normal: merge({}, getDefaultStyle(), {
          position: 'relative',
          boxSizing: 'border-box',
          margin: '0px',
          padding: '0px',
          color: '#CCCCCC',
          backgroundColor: 'transparent',
          display: 'block',
          overflow: 'hidden',
        }),
      },
      marquee: {
        normal: {
          transitionProperty: 'opacity',
          transitionDelay: '300ms',
          transitionDuration: '1s',
          whiteSpace: 'nowrap',
        },
        second: {
          position: 'absolute',
          right: '0px',
          left: '0px',
          top: '0px',
        },
        hidden: {
          opacity: '0',
          pointerEvents: 'none',
        },
      },
      item: {
        normal: merge({}, getDefaultStyle(), {
          display: 'inline-block',
          overflow: 'hidden',
          fontFamily: '"Courier New", Courier, monospace',
          padding: '8px 0px 0px 16px',
        }),
        hover: {},
      },
      label: {
        normal: merge({}, getDefaultStyle(), {
          display: 'inline-block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '40px',
          lineHeight: 1,
        }),
        hover: {},
      },
      icon: {
        normal: merge({}, getDefaultStyle(), {
          display: 'inline-block',
          width: '45px',
          height: '45px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50% 65%',
          backgroundSize: '150%',
          margin: '0px 0px 0px 0px',
        }),
        hover: {},
      },
      icons: [
        {
          name: 'down',
          url:
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='red' d='M7,10L12,15L17,10H7Z' /%3E%3C/svg%3E",
        },
        {
          name: 'down-small',
          url:
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='orange' d='M7,10L12,15L17,10H7Z' /%3E%3C/svg%3E",
          scale: '100%',
          position: '50% -2px',
        },
        {
          name: 'equal',
          url:
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='yellow' d='M19,10H5V8H19V10M19,16H5V14H19V16Z' /%3E%3C/svg%3E",
          scale: '90%',
          position: '50% 0px',
        },
        {
          name: 'up-small',
          url:
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%236a8000' d='M7,15L12,10L17,15H7Z' /%3E%3C/svg%3E",
          scale: '100%',
          position: '50% -2px',
        },
        {
          name: 'up',
          url:
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='green' d='M7,15L12,10L17,15H7Z' /%3E%3C/svg%3E",
        },
      ],
    };
  }

  return getDefaultTickerStyle.style;
}

export function getDefaultTicker() {
  // console.log('getDefaultTicker');
  if (!getDefaultTicker.source) {
    getDefaultTicker.source = document.createElement('div');
    getDefaultTicker.source.innerHTML =
      '<div class="body"><div class="marquee"></div><div class="marquee"></div></body>';
  }

  return getDefaultTicker.source.cloneNode(true);
}
